import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfirmationService } from 'primeng/api';
import { MessageService } from 'primeng/api';
import { IEmailFields } from 'app/shared/Domains/emailFields';
import { AppServiceManager } from 'common/services/appServiceManager';
import * as ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { IUser } from 'app/shared/Domains/IUser';
import { AuthService } from "./../../../common/services/auth.service";
import { IMember } from 'app/shared/Domains/member';
import { IBranch } from 'app/shared/Domains/branch';
import { LanguageService } from 'app/LanguageService/Language.Service';
@Component({
  selector: 'app-email-confirmation-modal',
  templateUrl: './email-confirmation-modal.component.html',
  styleUrls: ['./email-confirmation-modal.component.css']
})
export class EmailConfirmationModalComponent implements OnInit {
  public Editor = ClassicEditor;
  @Input() emailConfirmationModal: boolean;
  @Input() email: IEmailFields;
  @Input() company: any;
  @Input() getHtml: any;
  @Output() closeEmailComfirmationModal = new EventEmitter<any>();
  @Output() sendingBackBranchOwnerMail = new EventEmitter<any>();

  user: IUser;
  branch: IBranch;

  constructor(private LanguageService: LanguageService, private loader: NgxSpinnerService, private appServiceManager: AppServiceManager, private confirmationService: ConfirmationService, private messageService: MessageService) { }
  setLabel(label) {
    return this.LanguageService.GetCurrentLanguage("EmailConfirmationModalComponent", label);
  }
  ngOnInit() {
    this.user = AuthService.getLoggedInUser();
    this.getBranchByID()

  }

  dialogClose() {
    this.closeEmailComfirmationModal.emit();
  }

  sendEmailAsPdf() {
    // this.getBranchByID();
    let htmlToPdf = this.getHtml;
    this.confirmationService.confirm({
      message: "Are you sure you want to proceed ?",
      accept: () => {
        this.loader.show();
        this.appServiceManager.post('customers/sendEmailWhileInvoicePrint',
          {
            data: htmlToPdf,
            subject: this.email.subject,
            body: this.email.body,
            to: this.email.to,
            company: this.company

          }).subscribe((res) => {
            this.loader.hide();
            this.emailConfirmationModal = false;
            this.messageService.clear();
            this.messageService.add({ severity: 'success', summary: 'Success Message', detail: "Attachment Sent Successfully!" });
          },
            (error) => {
              this.loader.hide();
              this.emailConfirmationModal = false;
              this.messageService.clear();
              this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
            }
          )
      }
    });

  }

  getBranchByID() {
    this.branch = AuthService.getLoggedInCurrentBranch();
    if(this.branch){
      this.sendingBackBranchOwnerMail.emit(this.branch.contactPersonEmail)
    }
    if(!this.branch){
      this.appServiceManager.get("branches/" + this.user.branch).subscribe(
        (res: any) => {
          if (res) {
            this.branch = res;
            this.sendingBackBranchOwnerMail.emit(res.contactPersonEmail)
          } else {
            this.messageService.clear();
            this.messageService.add({
              severity: "info",
              summary: "Info Message",
              detail: "Something Went Wrong",
            });
          }
        },
        (error) => {
          this.messageService.clear();
          this.messageService.add({
            severity: "error",
            summary: "Error Message",
            detail: error,
          });
        }
      );

    }
  }

}
